export var ERewardOptionType;
(function (ERewardOptionType) {
    ERewardOptionType["PERCENTAGE"] = "percentage";
    ERewardOptionType["FIX"] = "fix";
})(ERewardOptionType || (ERewardOptionType = {}));
